// extracted by mini-css-extract-plugin
export var cardIcon = "_84-5";
export var cardIconUnframed = "_84-9";
export var checkboxCard = "_84-0";
export var checkboxCardSelected = "_84-4";
export var disabled = "_84-2";
export var interactive = "_84-1";
export var outerBorder = "_84-3";
export var spacerMedium = "_84-8";
export var spacerSmall = "_84-7";
export var spacerXsmall = "_84-6";